var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import { defaultProps } from './defaults';
import { DivTag, SpanTag, InputTag } from '../../Utils/AtomicTag';
import { omit } from '../../Utils/object';
import { throttle } from '@feb-team/data-logic';
import { ArrowDownOutlined, ArrowUpOutlined, MinusFunc, PlusFunc, } from '@feb-team/legao-icons-react';
var InputNumber = /** @class */ (function (_super) {
    __extends(InputNumber, _super);
    function InputNumber(props) {
        var _this = _super.call(this, props) || this;
        //方法
        _this.changeNum = function (num, type) {
            if (type === void 0) { type = 'null'; }
            if (_this.state.currNum !== num && _this.props.onBeforeChange()) {
                _this.props.onChange && _this.props.onChange(num);
                var stepHasMini = _this.props.step.toString();
                var miniData = stepHasMini.indexOf('.') > 0 ? stepHasMini[1].length : 0;
                _this.setState({
                    currNum: num,
                });
            }
            if (type === 'reduceNum') {
                _this.props.onReduce && _this.props.onReduce(num);
            }
            else if (type === 'addNum') {
                _this.props.onAdd && _this.props.onAdd(num);
            }
        };
        _this.handleChange = function (e) {
            _this.setState({
                timeNum: e.target.value,
            }, function () {
                _this.throttleChange();
            });
        };
        _this.handleBlur = function (e) {
            var value = parseFloat(e.target.value);
            var newValue = _this.props.decimalPlaces
                ? _this.formatDecimal(value.toString(), Number(_this.props.decimalPlaces))
                : value;
            _this.handleCurrNumber(newValue, true);
        };
        _this.handleCurrNumber = function (parmas, isBlur) {
            if (isBlur === void 0) { isBlur = false; }
            var _a = _this.props, max = _a.max, min = _a.min;
            var num = Number(parmas);
            if (!isNaN(num)) {
                if (num > max) {
                    num = max;
                }
                else if (num < min) {
                    num = min;
                }
            }
            else {
                num = parmas;
            }
            _this.changeNum(num, isBlur ? 'isBlur' : 'null');
        };
        _this.reduceNum = function () {
            if (_this.state.isLock)
                return;
            var currNum = Number(_this.state.currNum);
            var nextNum = Number(_this.floatSub(currNum, _this.props.step));
            var minNum = _this.props.min;
            currNum > minNum && nextNum > minNum && nextNum > Number.MIN_SAFE_INTEGER
                ? _this.changeNum(nextNum, 'reduceNum')
                : _this.changeNum(minNum, 'reduceNum');
        };
        _this.addNum = function () {
            if (_this.state.isLock)
                return;
            var currNum = Number(_this.state.currNum);
            var nextNum = Number(_this.floatAdd(currNum, _this.props.step).toFixed(3));
            var maxNum = _this.props.max;
            currNum < maxNum && nextNum < maxNum && nextNum < Number.MAX_SAFE_INTEGER
                ? _this.changeNum(nextNum, 'addNum')
                : _this.changeNum(maxNum, 'addNum');
        };
        var currNum = 'value' in props ? _this.props.value : _this.props.defaultValue;
        _this.state = {
            currNum: currNum,
            isLock: !!_this.props.value || !!_this.props.readOnly || !!_this.props.disabled,
            isChange: true,
            timeNum: 0,
        };
        return _this;
    }
    InputNumber.prototype.componentDidMount = function () {
        this.throttleChange = throttle(this.throttleChange, 100);
        this.handleCurrNumber(this.state.currNum);
    };
    InputNumber.prototype.componentWillReceiveProps = function (nextProps) {
        nextProps.defaultValue && this.changeNum(nextProps.defaultValue);
        nextProps.value && this.changeNum(nextProps.value);
    };
    InputNumber.prototype.throttleChange = function () {
        this.changeNum(this.state.timeNum);
    };
    InputNumber.prototype.formatDecimal = function (num, decimal) {
        num = num.toString();
        var index = num.indexOf('.');
        if (index !== -1) {
            num = num.substring(0, decimal + index + 1);
        }
        else {
            num = num.substring(0);
        }
        return parseFloat(num).toFixed(decimal);
    };
    //加
    InputNumber.prototype.floatAdd = function (arg1, arg2) {
        var r1, r2, m;
        try {
            r1 = arg1.toString().split('.')[1].length;
        }
        catch (e) {
            r1 = 0;
        }
        try {
            r2 = arg2.toString().split('.')[1].length;
        }
        catch (e) {
            r2 = 0;
        }
        m = Math.pow(10, Math.max(r1, r2));
        return (arg1 * m + arg2 * m) / m;
    };
    //减
    InputNumber.prototype.floatSub = function (arg1, arg2) {
        var r1, r2, m, n;
        try {
            r1 = arg1.toString().split('.')[1].length;
        }
        catch (e) {
            r1 = 0;
        }
        try {
            r2 = arg2.toString().split('.')[1].length;
        }
        catch (e) {
            r2 = 0;
        }
        m = Math.pow(10, Math.max(r1, r2));
        //动态控制精度长度
        n = r1 >= r2 ? r1 : r2;
        return ((arg1 * m - arg2 * m) / m).toFixed(n);
    };
    InputNumber.prototype.render = function () {
        var _this = this;
        var _a = this.state, currNum = _a.currNum, isLock = _a.isLock;
        var _b = this.props, type = _b.type, max = _b.max, min = _b.min, style = _b.style, readOnly = _b.readOnly, className = _b.className, rest = __rest(_b, ["type", "max", "min", "style", "readOnly", "className"]);
        //
        var reduceDisabled = isLock || currNum <= min;
        var addDisabled = currNum >= max || isLock;
        var disabledStatus = !!this.props.disabled || isLock;
        //样式
        //基础样式
        var inputWraperBasedCls = [
            'relative',
            'border-gray-400',
            'border-solid',
            'border',
            'rounded',
            'overflow-hidden',
        ];
        var boxsBaseCls = ['top-0', 'w-px-30', 'border-0', 'h-full'];
        var miniBasedBoxCls = ['right-0', 'w-px-22', 'bg-white'];
        //合并后的样式
        var inputWraperNormalCls = inputWraperBasedCls
            .concat(['w-px-100', 'h-px-32'])
            .concat(disabledStatus ? [] : ['px-px-30', 'hover:border-brand-400']);
        var inputWraperMiniCls = inputWraperBasedCls
            .concat(['w-px-64', 'h-px-30'])
            .concat(['pr-px-22']);
        var addReduceBox = [
            'absolute',
            'text-center',
            'cursor-pointer',
            'flex',
            'items-center',
            'justify-center',
        ];
        var addBox = addReduceBox.concat(boxsBaseCls, 'right-0');
        var reduceBox = addReduceBox.concat(boxsBaseCls, 'left-0');
        var addMiniBox = addReduceBox.concat(miniBasedBoxCls, ['top-0', 'z-0']);
        var reduceMiniBox = addReduceBox.concat(miniBasedBoxCls, [
            'bottom-0',
            'z-50',
        ]);
        var inputBox = ['block', 'h-full', 'text-center', 'border-0', 'w-full'];
        //适配迷你模式样式
        var halfWrapper = function () {
            var wrapperHeight = style.height || 30;
            if (wrapperHeight && type == 'mini') {
                var height = Number(wrapperHeight.toString().replace('px', ''));
                return {
                    height: height / 2 - 1 + 'px',
                };
            }
        };
        //
        var addStatusClass = addReduceBox
            .concat(
        //禁止样式
        addDisabled ? ['cursor-not-allowed', 'text-gray-400'] : ['hover:border-brand-400'])
            .concat(type == 'mini' ? addMiniBox : addBox);
        var reduceStatusClass = addReduceBox
            .concat(type == 'mini' ? reduceMiniBox : reduceBox)
            .concat(
        //禁止样式
        reduceDisabled ? ['cursor-not-allowed', 'text-gray-400'] : ['hover:border-brand-400']);
        var otherProps = omit(this.props, [
            'children',
            'defaultValue',
            'type',
            'step',
            'prefixCls',
            'isLock',
            'onBlur',
            'onReduce',
            'onAdd',
            'style',
            'className',
            'onBeforeChange',
            'decimalPlaces',
        ]);
        return (React.createElement(DivTag, { name: InputNumber.NAME, style: __assign({}, style), atomics: type == 'mini' ? inputWraperMiniCls : inputWraperNormalCls, className: disabledStatus
                ? className + ' wrapper-input  wrapper-input-disable'
                : type == 'mini'
                    ? className + ' wrapper-input input-mini-number'
                    : className + ' wrapper-input input-number' },
            disabledStatus ? (React.createElement(SpanTag, { atomics: reduceStatusClass, autoPrefixedClassName: type == 'mini' ? 'reduce-span-mini-box' : 'reduce-span-box', style: halfWrapper() },
                React.createElement("b", { className: "reduce-icon-disable icon-box" },
                    React.createElement(MinusFunc, null)))) : (React.createElement(SpanTag, { atomics: reduceStatusClass, autoPrefixedClassName: type == 'mini' ? 'reduce-span-mini-box' : 'reduce-span-box', onClick: this.reduceNum, style: halfWrapper() },
                React.createElement("b", { className: "reduce-icon icon-box" }, type == 'mini' ? React.createElement(ArrowDownOutlined, null) : React.createElement(MinusFunc, null)))),
            React.createElement(InputTag, __assign({}, otherProps, { atomics: inputBox, className: type == 'mini'
                    ? disabledStatus
                        ? 'mini-input-disable-box'
                        : 'mini-input-box'
                    : disabledStatus
                        ? 'disable-inputbox'
                        : 'inputbox', value: currNum, onBlur: function (e) {
                    _this.props.onBlur && _this.props.onBlur(e.target.value);
                    _this.handleBlur(e);
                }, onFocus: function (e) {
                    _this.props.onFocus && _this.props.onFocus();
                }, onChange: function (e) {
                    _this.handleChange(e);
                } })),
            disabledStatus ? (React.createElement(SpanTag, { autoPrefixedClassName: type == 'mini' ? 'add-span-mini-box' : 'add-span-box', atomics: addStatusClass, style: halfWrapper() },
                React.createElement("b", { className: "add-icon-disable icon-box" },
                    React.createElement(PlusFunc, null)))) : (React.createElement(SpanTag, { autoPrefixedClassName: type == 'mini' ? 'add-span-mini-box' : 'add-span-box', atomics: addStatusClass, onClick: this.addNum, style: halfWrapper() },
                React.createElement("b", { className: "add-icon icon-box" }, type == 'mini' ? React.createElement(ArrowUpOutlined, null) : React.createElement(PlusFunc, null))))));
    };
    InputNumber.defaultProps = defaultProps;
    InputNumber.NAME = 'input-number';
    InputNumber.displayName = 'InputNumber';
    return InputNumber;
}(PureComponent));
export { InputNumber };
